module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0049.png.7ac371dd.jpg";